module.exports = "a5cc8eac0c19b98fff20525a1d73214a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/star.png
// module id = 82
// module chunks = 0